import InputField, {AuthFieldProps} from './InputField';

export default function EmailField(props: AuthFieldProps) {
	return <InputField {...props} type='email' />;
}
